module.exports = __webpack_public_path__ + "media/packs/icheck/green-8cf8468691806390022148d5efdaad11.png";